export { InfoIcon } from './info'
